import React from "react";
import { useNavigation } from "@react-navigation/native";

import Button from "@/components/settings/Button";
import Callout from "@/components/settings/Callout";
import { t } from "@/localization";

// Business accounts have a team; anyone else who opens Team (a link, an old
// bookmark) learns how to get one.
const TeamsForBusiness = () => {
  const navigation = useNavigation();
  return (
    <Callout
      tone="info"
      action={
        <Button
          text={t("Update Profile")}
          size="sm"
          fullWidth={false}
          onPress={() => navigation.navigate("UpdateEmail")}
        />
      }
    >
      {t(
        "Teams is part of business accounts: invite people to work in your account with their own sign-in. To use it, choose Business as your account type in Profile › Update Profile."
      )}
    </Callout>
  );
};

export default TeamsForBusiness;
